export default __webpack_public_path__ + "static/media/Harvey.6ec16ab7.png";